/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UpdateAvatarRequestFromJSON(json) {
    return UpdateAvatarRequestFromJSONTyped(json, false);
}
export function UpdateAvatarRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        avatar: !exists(json, 'avatar') ? undefined : json['avatar'],
    };
}
export function UpdateAvatarRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        avatar: value.avatar,
    };
}
